var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5 18.4297H13.5L9.04999 21.3897C8.38999 21.8297 7.5 21.3597 7.5 20.5597V18.4297C4.5 18.4297 2.5 16.4297 2.5 13.4297V7.42969C2.5 4.42969 4.5 2.42969 7.5 2.42969H17.5C20.5 2.42969 22.5 4.42969 22.5 7.42969V13.4297C22.5 16.4297 20.5 18.4297 17.5 18.4297Z",
    fill: "#A1BAED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 12.1094C12.0898 12.1094 11.7498 11.7694 11.7498 11.3594V11.1494C11.7498 9.98941 12.5998 9.4194 12.9198 9.1994C13.2898 8.9494 13.4098 8.77941 13.4098 8.51941C13.4098 8.01941 12.9998 7.60938 12.4998 7.60938C11.9998 7.60938 11.5898 8.01941 11.5898 8.51941C11.5898 8.92941 11.2498 9.26941 10.8398 9.26941C10.4298 9.26941 10.0898 8.92941 10.0898 8.51941C10.0898 7.18941 11.1698 6.10938 12.4998 6.10938C13.8298 6.10938 14.9098 7.18941 14.9098 8.51941C14.9098 9.65941 14.0698 10.2294 13.7598 10.4394C13.3698 10.6994 13.2498 10.8694 13.2498 11.1494V11.3594C13.2498 11.7794 12.9098 12.1094 12.4998 12.1094Z",
    fill: "#437ADB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.5996C12.08 14.5996 11.75 14.2596 11.75 13.8496C11.75 13.4396 12.09 13.0996 12.5 13.0996C12.91 13.0996 13.25 13.4396 13.25 13.8496C13.25 14.2596 12.92 14.5996 12.5 14.5996Z",
    fill: "#437ADB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.0f3a52c9abc87ba833013b68c53523b1.svg";
export { ForwardRef as ReactComponent };